<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('homework.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('homework.pageTitle'),
            href: '/homeworks'
          },
          {
            text: $t('homework.correction'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-8">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form class="form-horizontal">
                <br />
                <br />
                <br />
                <br />
                <div
                  class="ts-border ts-rounded ts-border-blue-200 ts-border-opacity-20 ts-p-3"
                >
                  <teacher-profile :profile="teacherProfile" />
                  <br />
                  <br />
                  <homework-info :info="homework_resources" />
                </div>
                <br />
                <h1 class="ts-py-2">{{ $t('homework.studentList') }}</h1>
                <div
                  class="ts-border ts-rounded ts-border-blue-200 ts-border-opacity-20 ts-p-3"
                >
                  <student-list
                    v-model="homework_resources.student_homework"
                    @selectedStudent="onSeletedStudent"
                  />
                </div>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-4">
        <work-sheet-form :student="correction_student" />
        <br />
        <private-comment
          v-if="correction_student.student_homework_id"
          :studentHomeworkId="correction_student.student_homework_id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TeacherProfile from './component/teacher-profile'
import HomeworkInfo from './component/homework-info'
import StudentList from './component/student-list'
import WorkSheetForm from './component/work-sheet-form'
import PrivateComment from '../private-comment/index'

export default {
  name: 'homeworkCorrection',
  components: {
    TeacherProfile,
    HomeworkInfo,
    StudentList,
    WorkSheetForm,
    PrivateComment
  },
  data() {
    return {
      loading: false,
      homework_resources: {},
      correction_student: {}
    }
  },
  created() {
    this.fetchHomewrok()
  },
  computed: {
    teacherProfile() {
      return this.homework_resources.teacher
        ? this.homework_resources.teacher.photo
        : ''
    }
  },
  methods: {
    fetchHomewrok() {
      this.loading = true
      this.$store
        .dispatch('eschool/homeworkCorrection/fetch', this.$route.params.id)
        .then(response => {
          this.homework_resources = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSeletedStudent(value) {
      this.correction_student = Object.assign({}, value, {
        teacher_id: this.homework_resources.teacher_id
      })
    }
  }
}
</script>
